/* unplugin-vue-components disabled */import { render } from "./Transfer.vue?vue&type=template&id=475934ca&scoped=true"
import script from "./Transfer.vue?vue&type=script&lang=js"
export * from "./Transfer.vue?vue&type=script&lang=js"

import "./Transfer.vue?vue&type=style&index=0&id=475934ca&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475934ca"]])

export default __exports__